var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          class: "el-message el-message--" + _vm.type,
          staticStyle: { top: "20px", "z-index": "3000" },
          attrs: { role: "alert" },
          on: { mouseenter: _vm.enter, mouseleave: _vm.leave },
        },
        [
          _c("i", { class: "el-message__icon el-icon-" + _vm.type }),
          _c("div", { staticClass: "el-message__content" }, [
            _vm._v(_vm._s(_vm.content) + " "),
            _vm.hasClose
              ? _c("i", {
                  staticClass: "el-message__closeBtn el-icon-close",
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                })
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }